import DetailsOfCounterfeitGoods from './details_of_counterfeit_goods.vue';

export default DetailsOfCounterfeitGoods;
